import { FunctionComponent } from 'react';

import theme from '@/styles/theme';

interface PlusProps {
  color?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
}

/**
 * @default
 * color: theme.color.black
 * width: 18
 * height: 18
 * strokeWidth: 1.5
 */

const Plus: FunctionComponent<PlusProps> = ({
  color = theme.color.black,
  width = 18,
  height = 18,
  strokeWidth = 1.5,
}) => {
  return (
    <svg width={width} height={height} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3 9H15' stroke={color} strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round' />
      <path d='M9 3V15' stroke={color} strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default Plus;
